import React from 'react';

import './style.scss';

const PriceBoard = ({ img = '', title, icon = null }) => {
  return (
    <div className="image-card" style={{ backgroundImage: `url(${img})` }}>
      <div className={`image-card-content ${!icon ? 'has-no-icon' : ''}`}>
        {icon ? (
          <span className="image-card-content-icon">
            <img 
              alt="icon" 
              className="image-card-content-icon-img" 
              src={icon} 
              width={25} 
            />
          </span>
        ) : null}
        <span className="title">{title}</span>
      </div>
    </div>
  );
};

export default PriceBoard;
